import { createAction, props } from '@ngrx/store';

export const ENVIRONMENT_TYPE = "[App Component] Update Environment";

export const updateEnvironmentAction = createAction(ENVIRONMENT_TYPE, props<{
    payload: any
}>());